import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayDoubleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.2 24.3V7.7l8.6 8.3zm1-19a2 2 0 0 0-3.4 1.5v18.4a2 2 0 0 0 3.4 1.4l8.6-8.2v6.8a2 2 0 0 0 3.4 1.4l9.6-9.2a2 2 0 0 0 0-2.8l-9.6-9.2a2 2 0 0 0-3.4 1.4v6.8zM27.8 16l-8.6 8.3V7.7z" })
});
export default SvgPlayDoubleIcon;
